<div class="institution-typeahead">
  <div class="institution-typeahead__fields-row">
    <div class="institution-typeahead__field">
      <label c11n-label for="institution-search-field">{{
        content.INSTITUTION_SEARCH_LABEL
      }}</label>
      <c11n-input [size]="'medium'">
        <input
          c11nInput
          id="institution-search-field"
          type="text"
          [placeholder]="content.INSTITUTION_SEARCH_PLACEHOLDER"
          [value]="searchInput"
          (focus)="onSearchFocus()"
          (input)="onSearchInput($any($event.target).value)"
          (blur)="onSearchBlur()"
          autocomplete="off"
        />
      </c11n-input>

      <div
        *ngIf="showDropdown"
        class="institution-typeahead__dropdown"
        role="listbox"
        aria-label="Financial institution results"
      >
        <div
          *ngIf="isLoading"
          class="institution-typeahead__option institution-typeahead__option--status"
        >
          {{ content.INSTITUTION_LOADING }}
        </div>
        <ng-container *ngIf="!isLoading">
          <div
            *ngIf="searchInput.length < 3"
            class="institution-typeahead__option institution-typeahead__option--status"
          >
            {{ content.INSTITUTION_TYPE_MIN_CHARS }}
          </div>
          <ng-container *ngIf="searchInput.length >= 3">
            <div
              *ngIf="searchError"
              class="institution-typeahead__option institution-typeahead__option--status"
            >
              {{ content.INSTITUTION_SEARCH_UNAVAILABLE }}
            </div>
            <div
              *ngFor="let institution of results"
              class="institution-typeahead__option"
              role="option"
              (mousedown)="selectInstitution(institution)"
            >
              {{ institution.financialInstitutionName }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div *ngIf="isOtherSelected" class="institution-typeahead__field">
      <label c11n-label for="institution-other-name-field" [size]="'medium'">{{
        content.INSTITUTION_NAME_LABEL
      }}</label>
      <c11n-input [size]="'medium'">
        <input
          c11nInput
          id="institution-other-name-field"
          type="text"
          [placeholder]="content.INSTITUTION_NAME_PLACEHOLDER"
          [(ngModel)]="otherName"
          (ngModelChange)="onOtherNameInput($event)"
          (blur)="onOtherNameBlur()"
        />
      </c11n-input>
      <c11n-hint-error
        [hasError]="!validOtherName"
        [size]="'medium'"
        [errorText]="content.INSTITUTION_NAME_ERROR"
        hintErrorId="institution-other-name-error"
      ></c11n-hint-error>
    </div>
  </div>
</div>
